import request from '@/utils/request'

//获取核销未核查

//列表
export function getGmByHxWhc(data) {
  return request({
    method: 'get',
    url: '/yzdservice/api/enterprise/gmz/getGmByHxWhc?province=' + data.param.province +
      '&company=' + data.param.company +
      '&page=' + data.page +
      '&size=' + data.size
  })
}

//导出
export function excelwriterGmByHxWhc(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/gmz/excelwriterGmByHxWhc?province=" + data.province +
      '&company=' + data.company,
    responseType: 'blob',
  })
}

//获取行政区划级联树
export function getXzqTree() {
  return request({
    method: 'get',
    url: "/organization/api/xzqh/tree"
  })
}
